<script>
  export let card;

  const style = `background-image:url(/images/videos/${card.category}/img-${card.id}.jpg);`;
</script>

<style>
  .image {
    display: inline-flex;
    margin: auto auto;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: center center;
  }

  .image .play-button {
    height: 100%;
    width: 100%;
    background: url(/images/icons/button_play.svg), no-repeat;
    background-size: 100% 100%;
  }

  .image .play-button:hover {
    background: url(/images/icons/button_play_hover.svg), no-repeat;
    background-size: 100% 100%;
  }

  .image .play-button:active {
    background: url(/images/icons/button_play_pressed.svg), no-repeat;
    background-size: 100% 100%;
  }

  @media only screen and (max-width: 838px) {
    .image {
      background-position: right center;
    }
  }
</style>

<a href="{card.url}" target="_blank">
  <div class="image" {style}>
    <div class="play-button" />
  </div>
</a>
